const IMEI_PATTERN = /^\d{14,16}$/

export function normalizeImei(value) {
  if (value === null || value === undefined) return ''
  return String(value).trim()
}

export function isValidImei(value) {
  return IMEI_PATTERN.test(normalizeImei(value))
}

export function normalizeDeviceImeiPayload(payload) {
  const normalizeOne = (device) => {
    if (!device || typeof device !== 'object') return device
    return { ...device, imei: normalizeImei(device.imei) }
  }

  return Array.isArray(payload) ? payload.map(normalizeOne) : normalizeOne(payload)
}
